<section>
  <small *ngIf="labUserSw && realtime.configured() && !realtime.live()" class="live-off">{{
    "translate.inbox.liveOff" | translate
  }}</small>
  <ui-table
    *ngIf="displayOrders && displayOrders.length"
    [isWrapped]="false"
    [tblColor]="true"
    [tblRoundBottom]="true"
    [data]="displayOrders"
    [numberOfRows]="numberOfRows"
    [totalRecords]="totalRecords"
    [first]="paginatorFirst"
    [firstInputProvided]="true"
    (requestUpdate)="onUpdate($event)"
    (onRowSelect)="onRowSelect($event)"
    [selectedRow]="selectedOrder"
    [displayFilter]="displayColumnsList"
    [showPaginator]="true"
    [templates]="[
      {
        title: clinicUserSw
          ? 'translate.general.clinicDueDateFormatted'
          : 'translate.general.curDueDateFormatted',
        template: dueDate
      },
      {
        title: 'translate.general.stageDescr',
        template: stage,
        colClass: plantUserSw ? null : 'ui-p-2'
      },
      {
        template: urgency,
        title: 'translate.general.urgency',
        permission: displayUrgency,
        colClass: 'ui-p-5'
      },
      {
        colClass: 'l-ta-center ui-p-6',
        title: 'translate.general.chat',
        template: chat
      },
      {
        title: 'translate.general.tasks',
        colClass: 'l-ta-center ui-p-6',
        template: tasks,
        permission: displayTasks
      },
      {
        titleTemplate: rxTitle,
        colClass: 'l-ta-center ui-p-6',
        template: rx,
        permission: displayRx
      },
      {
        title: 'translate.general.inHouse',
        colClass: 'l-ta-center ui-p-6',
        template: inhouse,
        permission: displayInHouse
      },
      {
        template: favorite,
        colClass: 'cell-50',
        permission: true
      }
    ]"
    [colSet]="[
      {
        key: 'clinicDescr',
        colClass: 'ui-p-3'
      },
      {
        key: 'clinicId',
        colClass: 'ui-p-6'
      },
      {
        key: 'orderDateFormatted',
        colClass: 'ui-p-7'
      },
      {
        key: 'curDueDateFormatted',
        colClass: 'ui-p-5'
      },
      {
        key: 'plantDueDateFormatted',
        colClass: 'ui-p-3'
      },
      {
        key: 'doctorFullName',
        colClass: 'ui-p-7'
      },
      {
        key: 'doctorId',
        colClass: 'ui-p-7'
      },
      {
        key: 'patientFullName',
        colClass: plantUserSw ? 'ui-p-7' : null
      }
    ]"
  ></ui-table>
</section>

<ng-template #dueDate let-row="row">
  <div *ngIf="labUserSw" [class.c-warn]="row.alertDueDateChangeSw">
    {{ row.curDueDateFormatted }}
  </div>
  <div *ngIf="clinicUserSw" [class.c-warn]="row.alertDueDateChangeSw">
    {{ row.clinicDueDateFormatted }}
  </div>
  <div *ngIf="plantUserSw">{{ row.plantDueDateFormatted }}</div>
</ng-template>

<ng-template #chat let-row="row">
  <span class="fa-stack">
    <i
      class="fas fa-comment icon-chat fa-stack-2x"
      (click)="goToChat(row, $event)"
      [class.c-body]="row.totMsgCnt == 0"
      [class.c1]="row.unreadMsgCnt > 0"
      [class.c-grey-dark]="row.totMsgCnt > 0 && row.unreadMsgCnt == 0"
    ></i>
    <span *ngIf="row.unreadMsgCnt > 0" class="fa-stack-1x icon-chat-unread">
      {{ row.unreadMsgCnt }}
    </span>
  </span>
</ng-template>

<ng-template #favorite let-row="row">
  <i
    class="fa-star icon-fav"
    [class.fas]="row.favoriteSw"
    [class.selected]="row.favoriteSw"
    [class.far]="!row.favoriteSw"
    (click)="markFavorite(row, $event)"
  ></i>
</ng-template>

<ng-template #stage let-row="row">
  <order-stage-icon [order]="row"></order-stage-icon>
  <small *ngIf="row.intake?.takerName" class="intake-taken-by">{{
    "translate.inbox.takenBy" | translate : { name: row.intake.takerName }
  }}</small>
</ng-template>

<ng-template #urgency let-row="row">
  <order-urgency-icon [order]="row"></order-urgency-icon>
</ng-template>

<ng-template #inhouse let-row="row">
  <img *ngIf="!row.inhouseSw" src="assets\img\inhouse_off.svg" />
  <img *ngIf="row.inhouseSw" src="assets\img\inhouse.svg" />
</ng-template>

<ng-template #tasks let-row="row">
  <img
    *ngIf="row.totTasksCnt == 0"
    class="icon-task"
    src="assets\img\Flag_Grey.svg"
  />
  <img
    *ngIf="row.openTasksCnt > 0"
    class="icon-task"
    src="assets\img\Flag.svg"
  />
  <img
    *ngIf="row.totTasksCnt > 0 && row.openTasksCnt == 0"
    class="icon-task"
    src="assets\img\Flag_Dark_Grey.svg"
  />
</ng-template>

<ng-template #rxTitle>
  <div class="l-align-center">
    <checkbox-wrap class="checkbox inverted">
      <input
        type="checkbox"
        [(ngModel)]="toggleCheckAll"
        (ngModelChange)="onToggleAll()"
      />
    </checkbox-wrap>
    <span>&nbsp;</span>
    RX
    <span>&nbsp;</span>
    <i
      class="fas fa-chevron-down icon-th-down"
      (click)="
        displayDownloadRxPanel = !displayDownloadRxPanel;
        downloadRx.toggle($event)
      "
    ></i>
  </div>
</ng-template>

<ng-template #rx let-row="row">
  <div class="l-align-center">
    <checkbox-wrap
      *ngIf="row.hasRx"
      class="checkbox"
      (click)="$event.stopPropagation()"
    >
      <input type="checkbox" [(ngModel)]="row.checkedSw" />
    </checkbox-wrap>
    <span *ngIf="row.hasRx">&nbsp;</span>

    <div *ngIf="row.hasRx" style="position: relative">
      <i
        #rxIcon
        class="fas fa-file icon-rx"
        [class.c1]="row.hasRx"
        [class.c-body]="!row.hasRx"
      ></i>
      <span class="rx-counter">{{ row.filesRX.length }}</span>
    </div>
  </div>
</ng-template>

<p-popover
  #downloadRx
  [dismissable]="true"
  (onShow)="displayDownloadRxPanel = true"
  (onHide)="displayDownloadRxPanel = false"
  class="downloadRxPanel"
  appendTo="body"
>
  <div class="rx-options-container">
    <a
      [class.disabled]="!downloadSelectedRXEnabled"
      (click)="
        downloadSelectedRXEnabled ? downloadSelectedRX(downloadRx) : null
      "
      >{{ "translate.general.downloadAllSelectedFiles" | translate }}</a
    >
    <a
      [class.disabled]="!downloadRXOnPageEnabled"
      (click)="downloadRXOnPageEnabled ? downloadRXOnPage(downloadRx) : null"
      >{{ "translate.general.downloadAllFilesOnPage" | translate }}</a
    >
  </div>
</p-popover>
